'use strict';

var PricingAnalysisPanel = function PricingAnalysisPanel($stateProvider) {
  $stateProvider.state('app.pricing-analysis', {
    url: '/workflow/pricing-analysis',
    ifFeatureEnabled: ['DYNAMIC_AVAILABILITY'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: '<rm-pricing-analysis-panel></rm-pricing-analysis-panel>'
      },
      'mainToolbar': {
        template: require('../templates/pricing-analysis-toolbar.html'),
        controller: 'PricingAnalysisPanelToolbarController'
      }
    }
  });
};
module.exports = PricingAnalysisPanel;
PricingAnalysisPanel.$inject = ['$stateProvider'];